export const token = state => state.token
export const userInfo = state => state.userInfo
export const routerEveryLevel = state => state.routerEveryLevel
export const isLogin = state => state.isLogin
export const roleId = state => state.roleId